import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/containers/PartnerContainer/index.tsx");
